import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {AppSettings} from "../app.settings";
import {AgentUtility} from "../util/agent.utility";
import {Base2Service} from "./base2.service";
import {ResponseApi} from "./response/response";

export class ContactFilter {
    public name: string;
    public contractId?: number;
    public agentId: number;

    constructor(name: string, contractId: string, agentId: number) {
        this.name = name;
        this.contractId = Number.parseInt(contractId);
        this.agentId = agentId;
    }
}

@Injectable()
export class ContactService extends Base2Service {

    private _endpoint: string = AppSettings.apiUrl + AppSettings.PersonsEndpoint;

    // Запрашиваем уникальные имена, фамилии, отчества по ид агента.
    public getPeronsSource(agentId: number): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", this._endpoint + "/source/" + agentId);
    }

    // Запрашиваем данные клиентов по фильтру.
    public getPersonsByFilter(filter: ContactFilter): Observable<ResponseApi> {
        return this.request<ResponseApi>("POST", this._endpoint, JSON.stringify(filter));
    }

    // Запрашиваем инфу по клиенту.
    public getPersonInfo(CurrentId, PersonId): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", this._endpoint + "/info/" + CurrentId + "/" + PersonId);
    }
}